export default __webpack_public_path__ + "static/media/mixkit-guitar-notification-alert-2320.81f8c8d5.wav";